import { render, staticRenderFns } from "./social.vue?vue&type=template&id=f68424ee&scoped=true"
var script = {}
import style0 from "./social.vue?vue&type=style&index=0&id=f68424ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68424ee",
  null
  
)

export default component.exports